import { TaskError } from '../../errors/TaskError';
import { UploaderError } from '../../errors/UploaderError';
import { AbstractTask } from './AbstractTask';
import { UploadPart } from './UploadPart';
export class CreateParts extends AbstractTask {
    constructor(context, file, partsToCreate) {
        super(context);
        this.sdkFatalErrors = [
            this.context.transferSdk.errors.CreateTransferFilePartsError.UnauthorizedError,
            this.context.transferSdk.errors.CreateTransferFilePartsError.InvalidParameterError,
            this.context.transferSdk.errors.CreateTransferFilePartsError.NotFoundError,
            this.context.transferSdk.errors.CreateTransferFilePartsError.TransferAlreadyLockedError,
            this.context.transferSdk.errors.CreateTransferFilePartsError.FileAlreadyLockedError,
            this.context.transferSdk.errors.CreateTransferFilePartsError.UnknownError,
        ];
        this.transfer = context.transfer;
        this.file = file;
        this.partsToCreate = partsToCreate;
        this.createTransferFilePartsParameters = {
            transferId: context.transfer.id,
            fileId: file.id,
            parts: partsToCreate.map(part => ({ id: part.id })),
        };
    }
    preProcess(context) {
        return this;
    }
    process() {
        return new Promise(async (resolve) => {
            try {
                this.response = await this.context.transferSdk.createTransferFileParts(this.createTransferFilePartsParameters);
            }
            catch (error) {
                if (error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.UnauthorizedError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.NotFoundError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.InvalidParameterError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.TransferAlreadyLockedError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.FileAlreadyLockedError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.UnknownError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.InternalServerError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.GatewayTimeoutError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.BadGatewayError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.NetworkError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.TimeoutError ||
                    error instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.ConnectionAbortedError) {
                    this.error = new TaskError(this, error);
                }
                else {
                    this.error = new TaskError(this, error);
                }
            }
            resolve(this);
        });
    }
    postProcess(context) {
        const parts = this.transfer.populateCreatedParts(this.file, this.partsToCreate, this.response);
        parts.forEach(part => {
            context.uploadPartQueue.add(new UploadPart(context, this.file, part));
        });
        return null;
    }
    processError() {
        if (this.error) {
            if (this.error.isInstanceOfOneOfTheseErrors(this.sdkFatalErrors)) {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            else if (this.error.getError() instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.NetworkError ||
                this.error.getError() instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.TimeoutError ||
                this.error.getError() instanceof this.context.transferSdk.errors.CreateTransferFilePartsError.ConnectionAbortedError) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else if (this.executionNumber < this.maxExecutionNumber) {
                this.error.setRecoveryTask(this.error.getTask());
            }
            else {
                this.error.unrecoverableError(new UploaderError(this.error.getError()));
            }
            return this.error;
        }
        throw new Error('Method task.processError() should be called only if task.isOnError() === true');
    }
}
